import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import fieldsService from '../../services/fields.service';

import { IField, IProtocol, IProtocolsRequest } from '../../shared/interfaces';

import { Selection, CommandBar, DefaultButton, DetailsHeader, DetailsList, Text, DetailsListLayoutMode, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, IDetailsListStyles, IDetailsRowProps, Label, Link, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, TagPicker, ITag, IBasePicker, ScrollablePane, IScrollablePane, SearchBox, Icon, IPanelStyles, SelectionMode, TooltipHost, TooltipOverflowMode, ITooltipHostStyles } from '@fluentui/react';
import { reduxActions, RootState } from '../../store';

import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import { Indici_FormMode, Protocol_State } from '../../shared/enums';

import pdfImage from '../../assets/images/pdf.svg';

import DynamicForm from '../DynamicForm/DynamicForm';
import AppUtilities from '../../shared/Utilities/appUtilities';
import axios, { CancelTokenSource } from 'axios';
import CustomCommandBarButton from '../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import protocolsService from '../../services/protocols.service';


const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    emptyColumn: {

    }
});

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};


const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};
const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}
const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile
})

const mapDispatch = {
    //    setProtocolsTableState: (protocolsTableState: (Partial<IProtocolsTableState>)) => (reduxActions.navigationProtocolsActions.setProtocolsTableState(protocolsTableState)),
    //    unsetProtocolsTableState: () => (reduxActions.navigationProtocolsActions.unsetProtocolsTableState()),
    //    updateNavigationProtocolsState: (state: NavigationProtocolsState) => (reduxActions.navigationProtocolsActions.updateNavigationProtocolsState(state))
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface SearchAsStreamComponentBaseState {
    searchPanelIsOpen: boolean;
    commandBarItems: ICommandBarItemProps[];
    farItems: ICommandBarItemProps[];
    columns: IColumn[];
    tableFields: IField[];
    searchFormFields: IField[];
    staticFilter: Partial<IField>[];
    dynamicFilters: Partial<IField>[];
    nextLink: string | undefined;
    uorField: Partial<IField>;
    items: (IProtocol | null)[];
    totalRows: number;
    isLoadingProtocols: boolean;
    messageBarIsVisible: boolean;
    messageBarType: MessageBarType | undefined;
    messageBarText: string;
    selectedTags: any[];
    globalSearchValue: string;
}
export interface SearchAsStreamComponentBaseProps {
    cssClassName?: string
    searchFormFields: IField[]
    staticFilter?: Partial<IField>[]
    protocolReferencesSelection: Selection,
    selectionMode: SelectionMode
}

type Props = SearchAsStreamComponentBaseProps & RouteComponentProps & PropsFromRedux

class SearchAsStreamComponentBase extends React.Component<Props, SearchAsStreamComponentBaseState> {

    tagPickerRef = React.createRef<IBasePicker<ITag>>();
    cancelTokenSources = {};

    constructor(props) {
        super(props);
        this.state = {
            searchPanelIsOpen: false,
            commandBarItems: [],
            farItems: [],
            items: [],
            totalRows: 0,
            columns: [],
            tableFields: [],
            searchFormFields: [...this.props.searchFormFields],
            staticFilter: this.props.staticFilter ? [...this.props.staticFilter] : [],
            dynamicFilters: [],
            nextLink: undefined,
            uorField: {
                displayName: "Uor",
                internalName: "uor",
                controlType: "autocomplete",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: '',
                valid: false,
                touched: false,

            },
            isLoadingProtocols: true,
            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: '',
            selectedTags: [],
            globalSearchValue: '',
        };
    }
    componentDidMount() {
        this.updateCommandBarItems();
        if (this.props.currentAoo) {
            this.getFieldsAndProtocols()
        }
    }

    componentDidUpdate(oldProps, oldstate: SearchAsStreamComponentBaseState) {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.setState({
                isLoadingProtocols: true,
                items: [],
                nextLink: undefined
            }, this.getFieldsAndProtocols);
        }
        if (oldstate.dynamicFilters !== this.state.dynamicFilters) {
            this.updateCommandBarItems();
        }

    }

    componentWillUnmount() {
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }



    updateCommandBarItems = () => {
        let newCommandBarItems: ICommandBarItemProps[] = [];

        newCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        asDefaultButton={true}
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.openSearchPanel}
                    />

                )
            }
        );

        if ((this.state.dynamicFilters && this.state.dynamicFilters.length > 0)) {
            newCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchFormHandler}
                    />
                )
            });
        }

        this.setState({ commandBarItems: newCommandBarItems })
    }

    getFieldsAndProtocols = (oldProps?) => {
        if (this.props.currentAoo) {
            this.setState({ isLoadingProtocols: true })

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name]?.cancel("Request annullata");
            this.cancelTokenSources[protocolsService.getProtocolsAsStream.name]?.cancel("Request annullata");

            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name] = axios.CancelToken.source();

            fieldsService
                .getFieldsByViewName(this.props.currentAoo.id, "Tutti i protocolli", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
                .then(fields => {
                    let _fields = fields.filter(f => !f.system && f.internalName !== 'Title' && f.internalName !== 'ID');

                    let newColumns: IColumn[] = [
                        {
                            key: 'attachment',
                            name: 'attachment',
                            className: classNames.fileIconCell,
                            iconClassName: classNames.fileIconHeaderIcon,
                            iconName: 'Attach',
                            isIconOnly: true,
                            fieldName: 'attachments',
                            minWidth: 16,
                            maxWidth: 16,
                            onRender: (item) => {

                                if (item.hasAttachments)
                                    return <Icon iconName="Attach" style={{ fontSize: 16 }} />
                            },
                        }
                    ];


                    _fields.forEach(field => {
                        let col: IColumn = {
                            key: field.internalName,
                            fieldName: field.internalName,
                            name: field.displayName,
                            minWidth: 150,
                            isResizable: true,
                            ...field
                        };
                        if (field.internalName === 'Protocollo' || field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                            col.maxWidth = 110;
                            col.minWidth = 110;
                        } else if (field.internalName === "TipoProtocollo") {
                            col.maxWidth = 140;
                            col.minWidth = 140;
                        }
                        newColumns.push(col);
                    });

                    /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                    /// l'header e i contenuti della tabella 
                    if (!this.props.isMobile) {
                        newColumns.push(
                            {
                                key: 'empty',
                                name: 'empty',
                                fieldName: 'empty',
                                isIconOnly: true,

                                className: classNames.emptyColumn,
                                headerClassName: classNames.emptyColumn,
                                minWidth: 1,
                                maxWidth: 1,
                                onRender: (item) => {

                                },
                            },

                        );
                    }

                    let fixedFields = AppUtilities.fixFieldsForm(Indici_FormMode.Search, _fields);

                    this.setState({
                        columns: newColumns,
                        tableFields: fixedFields,
                        nextLink: undefined,
                        dynamicFilters: [],
                    }, () => { this.getProtocols() })
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        throw error;
                    }
                });


        }
    }


    getProtocols = () => {

        this.setState({ isLoadingProtocols: true })

        if (this.props.currentAoo) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolsAsStream.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolsAsStream.name] = axios.CancelToken.source();

            let protocolsRequest: IProtocolsRequest =
            {
                filters: [...this.state.staticFilter, ...this.state.dynamicFilters],
                nextLink: this.state.nextLink,
            }
            protocolsService
                .getProtocolsAsStream(this.props.currentAoo.id, protocolsRequest, this.cancelTokenSources[protocolsService.getProtocolsAsStream.name].token)
                .then(result => {
                    let currentItems = this.state.items.slice();

                    let itemsNewPage: (IProtocol | null)[] = result.protocols;

                    if (result.nextLink) {
                        itemsNewPage.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    this.setState({
                        messageBarIsVisible: false,
                        items: [...currentItems, ...itemsNewPage],
                        nextLink: result.nextLink,
                        isLoadingProtocols: false
                    });

                    delete this.cancelTokenSources[protocolsService.getProtocolsAsStream.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    this.setState({
                        items: [],
                        isLoadingProtocols: false
                    });
                });
        }
        // }
    }



    //tagPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    //    suggestionsHeaderText: 'Suggerimenti',
    //    mostRecentlyUsedHeaderText: 'Utenti suggeriti',
    //    noResultsFoundText: 'Nessun risultato trovato',
    //    loadingText: 'Caricamento',
    //    showRemoveButtons: false,
    //};

    //onTagPickerFilterChanged = async (
    //    filterText: string,
    //    currentTags?: ITag[],
    //): Promise<ITag[]> => {
    //    if (filterText) {
    //        let filteredSuggestions = await this.searchLookupSuggestions(filterText);

    //        if (currentTags)
    //            filteredSuggestions = this.removeTagPickerDuplicates(filteredSuggestions, currentTags);

    //        return filteredSuggestions;
    //    } else {
    //        return [];
    //    }
    //};


    //searchLookupSuggestions = async (filterText: string): Promise<ITag[]> => {
    //    let result: ITag[] = [];
    //    let { currentAoo } = this.props;
    //    if (currentAoo && filterText) {
    //        // il cancelToken risulta diverso da null se la request è in pending in tal caso annullo la vecchia request
    //        this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name]?.cancel("Request annullata");

    //        // Ricreo il cancel token ad ogni request
    //        this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name] = axios.CancelToken.source();

    //        await uorsService.getUorSuggestionsForCurrentUser(currentAoo.id, filterText, this.cancelTokenSources[uorsService.getUorSuggestionsForCurrentUser.name].token)
    //            .then(suggestions => {
    //                result = suggestions.reduce((a: ITag[], o) => (o && a.push({ key: o.id!, name: o.nome! }), a), [])
    //            })
    //            .catch(error => {
    //                if (axios.isCancel(error)) {
    //                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
    //                    console.log(error.message);
    //                } else {
    //                    throw error;
    //                }
    //            });
    //    }

    //    return result;

    //}

    //removeTagPickerDuplicates = (items: ITag[], possibleDupes: ITag[]) => {
    //    return items.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
    //}

    //onTagSelected = (selectedItem: any): ITag | null => {
    //    // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
    //    // gli elementi selezionati tramiteinputChanged(selectedItem) che setta l'internalValue del campo
    //    return selectedItem;
    //}
    //onTagPickerItemsChange = (items?: any[]): void => {
    //    this.setState({
    //        uorField: { ...this.state.uorField, internalValue: items }
    //    });
    //};

    openSearchPanel = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ searchPanelIsOpen: true })
    }

    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }



    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let currentItems = this.state.items.slice();
        currentItems.pop();
        this.setState({
            items: currentItems
        }, () => { this.getProtocols() })
        return null;
    };

    formInputChangedHandler = (newField: IField) => {

        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        });

    }

    resetSearchFormHandler = () => {
        let { searchFormFields, uorField } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] },
            globalSearchValue: '',
            isLoadingProtocols: true,
            items: [null],
            nextLink: undefined,
            dynamicFilters: [],

        });

    }
    resetSearchFields = () => {
        let { searchFormFields, uorField } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields,
            uorField: { ...uorField, internalValue: [] }
        });
    }

    // Click su salva del panel laterale
    searchLateralPanelSubmit = () => {

        let { searchFormFields } = this.state;

        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsInternalValueForSearchSubmit([...touchedFields]);

        this.setState({
            globalSearchValue: '',
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: [],
            nextLink: undefined,
            dynamicFilters: [...fixedFields]
        }, () => { this.getProtocols() })

    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    //navigate = (ev, item?: IProtocol) => {
    //    ev?.preventDefault();
    //    ev?.stopPropagation();
    //    this.props.setProtocol(item!);
    //    //aggiunge gli zeri prima del numero
    //    const zeroPad = (num, places) => String(num).padStart(places, '0');
    //    let path;
    //    if (item && item.id && item.numeroProtocollo) {
    //        let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;

    //        path = `${this.props.match.url.replace('/ricerca', '')}/${item.id}/${protocolnumber}`;

    //    } else if (item && item.id) {

    //        path = `${this.props.match.url.replace('/ricerca', '')}/edit/${item.id}`;
    //    }
    //    this.props.history.push({ pathname: path, search: this.props.location.search });

    //}
    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.id) {
            this.props.setProtocol(item!);
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;
            let path;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    path = `/${this.props.currentAoo!.id}/${item.id}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    path = `/${this.props.currentAoo!.id}/allocated/${item.id}/${protocolnumber}`;
                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    path = `/${this.props.currentAoo!.id}/edit/${item.id}`;
                    break;

            }
            this.props.history.push({ pathname: path, search: this.props.location.search });
        }
    }


    onRenderItemColumn = (item?: IProtocol, index?: number | undefined, column?) => {
        let displayValue = this.extractDisplayValueAndColumnContent(item, column);

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {displayValue}
            </TooltipHost>
        );
    }

    extractDisplayValueAndColumnContent = (item: IProtocol | undefined, column: any) => {
        let displayValue = "-";
        let columnInternalName = column?.fieldName;


        if (item) {
            let protocol: IProtocol = { ...item };
            const fieldContent = protocol.fields?.find(it => it.internalName === columnInternalName);
            if (fieldContent) {
                const fieldColumnMerge: IField = { ...column, internalValue: fieldContent?.internalValue };
                displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldColumnMerge);

            }
        }
        return displayValue;
    }

    onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.searchLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFields()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }


    public render() {
        return (
            <div className={`search-component ${this.props.cssClassName}`}>
                <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={this.state.commandBarItems}
                    farItems={this.state.farItems}
                    styles={commandBarStyles}

                />

                {this.state.items.length > 0 &&
                    <DetailsList
                        className="with-empty-column"
                        styles={detailsListStyles}
                        items={this.state.items}
                        columns={this.state.columns}
                        onRenderItemColumn={this.onRenderItemColumn}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        selection={this.props.protocolReferencesSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={this.props.selectionMode}

                    />
                }
                {this.state.items.length === 0 &&

                    <Text block style={{ padding: 25 }}>Nessun risultato trovato.</Text>
                }


                <Panel
                    isLightDismiss
                    isOpen={this.state.searchPanelIsOpen}
                    type={PanelType.custom}
                    customWidth={'600px'}
                    headerText={'Filtri di ricerca'}
                    id={'searchFormPanel'} // l'ID 'searchFormPanel' viene usato nel component INPUT per gestire il click esterno al calendario
                    onDismiss={this.dismissSearchPanel}
                    onRenderFooterContent={this.onRenderLateralPanelFooterContent}

                    closeButtonAriaLabel="Close"
                    isHiddenOnDismiss={false}
                >
                    {this.state.messageBarIsVisible &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }


                    <div className={`search-form-dialog flex flex-column position-relative`}>

                        <div className={`my-component-content`}>
                            <div className={this.state.uorField.touched && !this.state.uorField.valid ? 'field error' : 'field'}>
                                {/*<Label className='field-label' htmlFor={this.state.uorField.internalName} required={this.state.uorField.required}>{this.state.uorField.displayName}</Label>*/}
                                {/*<TagPicker styles={{ root: { paddingBottom: '20px' } }}*/}
                                {/*    key={this.state.uorField.internalName}*/}
                                {/*    componentRef={this.tagPickerRef}*/}
                                {/*    getTextFromItem={getTextFromTagItem}*/}
                                {/*    selectedItems={this.state.uorField.internalValue}*/}
                                {/*    itemLimit={1}*/}
                                {/*    pickerSuggestionsProps={this.tagPickerSuggestionsProps}*/}

                                {/*    onResolveSuggestions={this.onTagPickerFilterChanged}*/}
                                {/*    onItemSelected={this.onTagSelected}*/}
                                {/*    onChange={this.onTagPickerItemsChange}*/}
                                {/*    resolveDelay={400}*/}


                                {/*/>*/}
                                <DynamicForm
                                    fields={this.state.searchFormFields}
                                    onInputChangedHandler={(newField) => { this.formInputChangedHandler(newField) }}
                                    formMode={Indici_FormMode.Search}
                                />

                                {this.state.uorField.touched && !this.state.uorField.valid && <span className="error-message">Campo obbligatorio</span>}
                            </div>

                        </div>

                    </div>







                </Panel>


            </div>

        );
    }

}



export default connector(withRouter(SearchAsStreamComponentBase));




function getTextFromTagItem(tag: ITag): string {
    return tag.name as string;
}
